import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, CommandBarButton, Image, ImageFit, Icon, Text, FocusZone, IconButton } from '@fluentui/react';
import { AppContext } from '../../../context/context.esm.js';
import SuggestionContext from '../SuggestionContext.esm.js';
import { useContext } from 'react';
import { CONSULTING_SERVICES } from '@agoras/rest-client';
import { SuggestionTypes } from '../types.esm.js';
import LinkedAddIns from './LinkedAddIns.esm.js';
import { styles, listButton } from './SuggestionItem.style.esm.js';
import { useTranslation } from 'react-i18next';

var ROUTES = {
    APP_DETAILS: 'appDetails',
    SERVICE_DETAIL: 'serviceDetail',
    PARTNER_SUGGESTION: 'marketplacePartnerSuggestion'
};
var SuggestionItem = function(param) {
    var item = param.item, isFirstItem = param.isFirstItem, children = param.children;
    var _useContext = useContext(AppContext), navigate = _useContext.navigate, unifiedExperience = _useContext.unifiedExperience;
    var _useContext1 = useContext(SuggestionContext), onClickSuggestionItem = _useContext1.onClickSuggestionItem, onDismissSuggestions = _useContext1.onDismissSuggestions, onFirstSuggestionKeyDown = _useContext1.onFirstSuggestionKeyDown, onRemoveHistoryItem = _useContext1.onRemoveHistoryItem;
    var _useTranslation = useTranslation('search', {
        keyPrefix: 'ProductType'
    }), productTypeTranslate = _useTranslation.t;
    if (!item) {
        return null;
    }
    var id = item.id, displayText = item.displayText, suggestionType = item.suggestionType, iconUrl = item.iconUrl, productType = item.productType, linkedAddInsTypes = item.linkedAddInsTypes;
    var handleClickItem = function() {
        onDismissSuggestions();
        onClickSuggestionItem(item);
        if (suggestionType === SuggestionTypes.Entity) {
            var urlType = productType === CONSULTING_SERVICES ? ROUTES.SERVICE_DETAIL : ROUTES.APP_DETAILS;
            navigate({
                type: urlType,
                params: {
                    productId: productType,
                    entityId: id
                }
            });
            return;
        }
        if (suggestionType === SuggestionTypes.Partner) {
            navigate({
                type: ROUTES.PARTNER_SUGGESTION,
                query: {
                    text: displayText,
                    value: id,
                    type: productType
                }
            });
            return;
        }
    };
    var getProductTypeText = function(productType) {
        if (productType === CONSULTING_SERVICES) {
            if (unifiedExperience) {
                return productTypeTranslate('ConsultingServicesUnified');
            }
            return productTypeTranslate('ConsultingServices');
        }
        return productTypeTranslate(String(productType));
    };
    return /*#__PURE__*/ jsxs(Stack, {
        className: styles.container,
        horizontal: true,
        children: [
            /*#__PURE__*/ jsxs(CommandBarButton, {
                styles: listButton,
                role: suggestionType === SuggestionTypes.Entity ? 'link' : 'button',
                onClick: handleClickItem,
                title: displayText,
                onKeyDown: isFirstItem ? onFirstSuggestionKeyDown : undefined,
                "data-is-focusable": true,
                children: [
                    suggestionType === SuggestionTypes.Entity ? /*#__PURE__*/ jsx(Image, {
                        className: styles.offerIcon,
                        src: iconUrl,
                        alt: "".concat(displayText, " icon"),
                        imageFit: ImageFit.cover,
                        maximizeFrame: true
                    }) : suggestionType !== SuggestionTypes.Partner && /*#__PURE__*/ jsx(Icon, {
                        className: styles.suggestionIcon,
                        iconName: suggestionType === SuggestionTypes.History ? 'History' : 'Search'
                    }),
                    /*#__PURE__*/ jsxs(Stack, {
                        horizontalAlign: "start",
                        styles: {
                            root: {
                                '>:nth-child(3)': {
                                    marginTop: 8
                                },
                                textAlign: 'left'
                            }
                        },
                        children: [
                            children,
                            Boolean(productType) && suggestionType !== SuggestionTypes.Partner && /*#__PURE__*/ jsx(Text, {
                                className: styles.productType,
                                as: "h3",
                                variant: "small",
                                children: getProductTypeText(String(productType))
                            }),
                            Boolean(linkedAddInsTypes) && /*#__PURE__*/ jsxs(Stack, {
                                horizontal: true,
                                verticalAlign: "center",
                                className: styles.integratedWithCard,
                                grow: false,
                                children: [
                                    /*#__PURE__*/ jsx(Text, {
                                        className: styles.integratedWithText,
                                        variant: "xSmall",
                                        children: "Integrated with:"
                                    }),
                                    /*#__PURE__*/ jsx(LinkedAddIns, {
                                        items: linkedAddInsTypes,
                                        id: id
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "search:suggestion:".concat(suggestionType, ":").concat(id)),
            suggestionType === SuggestionTypes.History && /*#__PURE__*/ jsx(FocusZone, {
                disabled: true,
                children: /*#__PURE__*/ jsx(IconButton, {
                    title: "Remove",
                    ariaLabel: "remove from history",
                    onClick: function() {
                        return onRemoveHistoryItem(item);
                    },
                    iconProps: {
                        iconName: 'Blocked12',
                        className: styles.historyIcon
                    },
                    className: styles.historyButton
                })
            })
        ]
    });
};

export { SuggestionItem as default };
